import builder from '../builder';
import ArrowButtonUp from '../../streamline-icons/bold/arrow-button-up.svg';

export default builder('IconArrowButtonUpBold', ArrowButtonUp);
